import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 'bold',
  fontSize: 16,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1.5)
}))

export default StyledLabel
